import { EventLogTabContent } from '../../../event-panel/tabs/event-log/event-log-tab-content';
import { useGetEventIdAndTabNameFromParams } from '../../hooks/use-get-event-id-and-tab-name-from-params';
import { FrTabContentWrapper } from './styled';

export default function FrEventLogTab() {
    const { eventId } = useGetEventIdAndTabNameFromParams();

    return (
        <FrTabContentWrapper>
            <EventLogTabContent eventId={eventId} />
        </FrTabContentWrapper>
    );
}
